import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  InputGroup,
} from 'reactstrap';
import React from 'react';
import { useMemo, useRef } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
//import { useMutation, gql } from '@apollo/client';
import { get, map, split, sortBy } from 'lodash-es';
import { useMutation, useQueryClient } from 'react-query';
//import './createCharger.css';
import { editCharger } from '../../utils/queries/hostQueries';
import { toast } from 'react-toastify';
import { createUseStyles } from 'react-jss';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from 'react-leaflet';

import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import vendors from '../../utils/vendors';
import { vehicleTypes } from '../../utils/misc';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '700px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
  },
  addMore: {
    marginTop: '15px',
    backgroundColor: '#2675b8',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
  },
  addCharger: {
    backgroundColor: '#2675b8',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
    marginTop: '15px',
    width: '100%',
  },
  timeRangePickerFrom: {
    width: '36%',
    marginLeft: '11px',
    borderRadius: '6px',
    backgroundColor: 'white',
    '& .rc-time-picker-input': {
      height: '38px',
      fontSize: '15px',
    },
  },
});

const center = {
  lat: 22.505,
  lng: 80.09,
};

function DraggableMarker({ position, setPosition }) {
  const map = useMapEvents({
    click() {
      map.locate();
    },
    locationfound(e) {
      setPosition('coords', {
        lat: e.latlng.lat,
        lng: e.latlng.lng,
      });
      map.flyTo(e.latlng, map.getZoom());
    },
  });

  const markerRef = useRef(null);
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        setPosition('coords', {
          lat: marker.getLatLng().lat,
          lng: marker.getLatLng().lng,
        });
      },
    }),
    [setPosition],
  );

  return (
    <Marker
      draggable={true}
      eventHandlers={eventHandlers}
      position={position}
      ref={markerRef}
    >
      <Popup minWidth={90}>
        <span>Drag and Drop the marker to set Coordinates</span>
      </Popup>
    </Marker>
  );
}

export default function CreateChargerModal({
  toggleEditChargerModalOpen,
  editChargerModalOpen,
  charger,
}) {
  const classes = useStyles();
  const queryQlient = useQueryClient();
  const { mutateAsync: updateCharger } = useMutation(editCharger);

  //Actually update the charger
  async function updateChargerInfo(values, setSubmitting) {
    try {
      setSubmitting(true);
      const formattedValues = {
        ID: values.id,
        NAME: values.cpName,
        MODEL: values.model,
        IS_DC: values.chargerType === 'DC' ? 1 : 0,
        ADDRESS: values.address,
        LATITUDE: values.coords.lat,
        LONGITUDE: values.coords.lng,
        ZIPCODE: values.zipcode,
        CONNECTORS: map(get(values, 'connectors'), (conn) => {
          return {
            TYPE: conn.TYPE,
            CONNECTOR_ID: conn.CONNECTOR_ID,
            CPID: values.id,
          };
        }),
        TIMING: convertToJoulepoinTimingFormatString(
          values.timingFrom,
          values.timingTo,
        ),
        BASE_KWH_COST: values.tariff,
        ENERGY: values.energy,
        VEHICLE_TYPE: values.vehicleType,
      };
      const updatedCharger = await updateCharger(formattedValues);

      queryQlient.setQueryData('host/chargers', (oldData) => {
        const newMutatedData = map(oldData, (data) => {
          if (data.ID === charger.ID) {
            return updatedCharger;
          } else {
            return data;
          }
        });
        return newMutatedData;
      });
      queryQlient.setQueryData(['host/charger', charger.ID], (oldData) => {
        return updatedCharger;
      });
      queryQlient.fetchQuery(['host/charger', charger.ID]);
      queryQlient.fetchQuery('host/chargers');
      toast.dark('Charger updated.', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      toggleEditChargerModalOpen();
    } catch (error) {
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setSubmitting(false);
  }
  /* ------------Time Picker--------- */

  function getTiming(timeRange) {
    const parsedTimeRange = split(timeRange, '-');
    const from = parsedTimeRange[0];
    const to = parsedTimeRange[1];
    return {
      from,
      to,
    };
  }

  function convertToJoulepoinTimingFormatString(from, to) {
    return `${from}-${to}`;
  }

  function parseTime(time) {
    const now = moment().format('DD-MM-YYYY');
    const fullDateTimeString = `${now} ${time}`;
    return moment(fullDateTimeString, 'DD-MM-YYYY hh:mm A');
  }
  /* --------------------------- */
  return (
    <Modal
      isOpen={editChargerModalOpen}
      toggle={toggleEditChargerModalOpen}
      className={classes.modal}
    >
      <ModalHeader toggle={toggleEditChargerModalOpen}>
        Edit Charger
      </ModalHeader>
      <ModalBody style={{ marginTop: '-30px' }}>
        <Formik
          initialValues={{
            id: get(charger, 'ID'),
            vendor: get(charger, 'VENDOR'),
            model: get(charger, 'MODEL'),
            cpName: get(charger, 'NAME'),
            address: get(charger, 'ADDRESS'),
            coords: {
              lat: get(charger, 'LATITUDE'),
              lng: get(charger, 'LONGITUDE'),
            },
            connectors: sortBy(
              get(charger, 'CONNECTORS'),
              (conn) => conn.CONNECTOR_ID,
            ),
            zipcode: get(charger, 'ZIPCODE'),
            chargerType: get(charger, 'IS_DC') === 0 ? 'AC' : 'DC',
            timingFrom: getTiming(get(charger, 'TIMING')).from,
            timingTo: getTiming(get(charger, 'TIMING')).to,
            tariff: get(charger, 'BASE_KWH_COST'),
            energy: get(charger, 'ENERGY'),
            vehicleType: get(charger, 'VEHICLE_TYPE'),
          }}
          onSubmit={async (values, { resetForm, setSubmitting }) => {
            await updateChargerInfo(values, setSubmitting);
          }}
        >
          {({ values, isSubmitting, setFieldValue }) => (
            <Form>
              <div className="form-group">
                <div className="row">
                  <div className="col-12 mb-3">
                    <Label>Charger Id</Label>
                    <Field
                      name="id"
                      type="string"
                      className="form-control"
                      id="chargepointId"
                      aria-describedby="chargepoint"
                      placeholder="Leave Empty to auto generate"
                      disabled
                    />
                  </div>
                  <div className="col-12 mb-3">
                    <Label>Charger Name</Label>
                    <Field
                      name="cpName"
                      type="string"
                      className="form-control"
                      id="chargepointName"
                      aria-describedby="chargepoint"
                      placeholder="Charger Name"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <Label>Vendor</Label>
                    {/* <Field
                      name="vendor"
                      type="string"
                      className="form-control"
                      id="vendor"
                      aria-describedby="chargepoint"
                      placeholder="Vendor"
                      disabled={isSubmitting}
                    /> */}
                    <Field
                      as="select"
                      name="vendor"
                      disabled
                      id="vendor"
                      style={{
                        width: '100%',
                        height: '43px',
                        borderRadius: '6px',
                        padding: '8px',
                        backgroundColor: 'white',
                        border: '1px solid #d4d9df',
                      }}
                    >
                      {map(vendors, (vendor, v) => (
                        <option value={vendor} key={v}>
                          {vendor}
                        </option>
                      ))}
                    </Field>
                  </div>
                  <div className="col-6 mb-3">
                    <Label>Model</Label>
                    <Field
                      name="model"
                      type="string"
                      className="form-control"
                      id="model"
                      aria-describedby="chargepoint"
                      placeholder="Model"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div
                    className="col-5 mb-3 mt-2"
                    style={{ display: 'flex', alignItems: 'flex-end' }}
                  >
                    <div>
                      <Label>Charger Type</Label>
                      <label style={{ marginLeft: '20px' }}>
                        <Field type="radio" name="chargerType" value="AC" />{' '}
                        {'  '}AC
                      </label>
                      <label style={{ marginLeft: '20px' }}>
                        <Field type="radio" name="chargerType" value="DC" /> DC
                      </label>
                    </div>
                  </div>
                  <div className="col-12 mb-3 mt-2">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Label for="exampleTime">Open Timing</Label>

                      <TimePicker
                        name="timingFrom"
                        showSecond={false}
                        defaultValue={parseTime(values.timingFrom)}
                        className={classes.timeRangePickerFrom}
                        onChange={(value) => {
                          setFieldValue('timingFrom', value.format('hh:mm A'));
                        }}
                        format="hh:mm A"
                        use12Hours
                        inputReadOnly
                      />

                      <Label for="exampleTime" style={{ marginLeft: '8px' }}>
                        to
                      </Label>

                      <TimePicker
                        name="timingTo"
                        showSecond={false}
                        defaultValue={parseTime(values.timingTo)}
                        className={classes.timeRangePickerFrom}
                        onChange={(value) => {
                          setFieldValue('timingTo', value.format('hh:mm A'));
                        }}
                        format="hh:mm A"
                        use12Hours
                        inputReadOnly
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <Label>Vehicle Type</Label>
                    {/* <Field
                      name="vendor"
                      type="string"
                      className="form-control"
                      id="vendor"
                      aria-describedby="chargepoint"
                      placeholder="Vendor"
                      disabled={isSubmitting}
                    /> */}
                    <Field
                      as="select"
                      name="vehicleType"
                      disabled={isSubmitting}
                      id="vendor"
                      style={{
                        width: '100%',
                        height: '43px',
                        borderRadius: '6px',
                        padding: '8px',
                        backgroundColor: 'white',
                        border: '1px solid #d4d9df',
                        color: '#8b9bac',
                      }}
                    >
                      {map(vehicleTypes, (type, t) => (
                        <option
                          value={type.id}
                          key={t}
                          style={{ color: '#8b9bac' }}
                        >
                          {type.name}
                        </option>
                      ))}
                    </Field>
                  </div>
                  <div className="col-12 mt-1">
                    <div>
                      <FormGroup>
                        <Label>Tariff</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>₹</InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="number"
                            value={values.tariff}
                            onChange={(e) => {
                              if (e.target.value <= 30) {
                                setFieldValue('tariff', e.target.value);
                              }
                            }}
                            name="tariff"
                          />
                        </InputGroup>
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col-12 mt-1">
                    <div>
                      <FormGroup>
                        <Label>Charger Capacity</Label>
                        <InputGroup>
                          <Input
                            value={values.energy}
                            onChange={(e) =>
                              setFieldValue('energy', e.target.value)
                            }
                            name="energy"
                            type="number"
                          />
                          <InputGroupAddon addonType="append">
                            <InputGroupText>KW</InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <Label>Address</Label>
                    <Field
                      name="address"
                      type="string"
                      className="form-control"
                      id="address"
                      aria-describedby="chargepoint"
                      placeholder="Address"
                      component="textarea"
                      rows="1"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="col-12 mb-3">
                    <Label>Zipcode</Label>
                    <Field
                      name="zipcode"
                      type="number"
                      className="form-control"
                      id="zipcode"
                      aria-describedby="chargepoint"
                      placeholder="Zipcode"
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <MapContainer
                      center={center}
                      zoom={4}
                      scrollWheelZoom={false}
                      style={{
                        height: '400px',
                      }}
                    >
                      <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <DraggableMarker
                        position={values.coords}
                        setPosition={setFieldValue}
                      />
                    </MapContainer>
                  </div>

                  <div className="col-6 mb-3">
                    <Label>Longitude</Label>
                    <Field
                      name="coords.lng"
                      type="number"
                      className="form-control"
                      id="coordinateX"
                      aria-describedby="chargepoint"
                      placeholder="logitude"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <Label>Latitude</Label>
                    <Field
                      name="coords.lat"
                      type="number"
                      className="form-control"
                      id="coordinateY"
                      aria-describedby="chargepoint"
                      placeholder="latitude"
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className="col-12 ">
                    <Label>Connectors</Label>
                  </div>
                  <div className="col-12 mb-3 mt-2">
                    <FieldArray
                      name="connectors"
                      render={(arrayHelpers) => (
                        <div>
                          {values.connectors.map((connector, index) => (
                            <div
                              className="row"
                              key={index}
                              style={{ marginBottom: '10px' }}
                            >
                              <div
                                className="col-3"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Button
                                  color="danger"
                                  style={{
                                    marginRight: '10px',
                                    backgroundColor: '#f95656',
                                    border: 'none',
                                  }}
                                  size="sm"
                                  disabled
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  <i class="fas fa-trash"></i>
                                </Button>
                                Connector {index + 1}
                              </div>
                              <div
                                className="col-9"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Field
                                  as="select"
                                  name={`connectors.${index}.TYPE`}
                                  disabled
                                  id="type"
                                  style={{
                                    width: '100%',
                                    borderRadius: '3px',
                                    padding: '10px',
                                    backgroundColor: 'white',
                                    border: '1px solid #d4d9df',
                                  }}
                                >
                                  <option value="CCS1">CCS-1</option>
                                  <option value="CCS2">CCS-2</option>
                                  <option value="CHADEMO">CHAdeMO</option>
                                  <option value="TYPE2">Type-2</option>
                                </Field>
                              </div>
                            </div>
                          ))}
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {/* <Button
                              color="primary"
                              className={classes.addMore}
                              onClick={() =>
                                arrayHelpers.push({
                                  TYPE: '',
                                })
                              }
                              disabled={isSubmitting}
                            >
                              Add More
                            </Button> */}
                          </div>
                        </div>
                      )}
                    />
                  </div>
                  <div className="col-12">
                    <Button
                      color="primary"
                      className={classes.addCharger}
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Update Charger Details
                    </Button>
                  </div>
                  {/* {afterCreateAlert ? (
                    <div className="col-12 mt-3">
                      <Alert
                        variant="success"
                        onClose={() => setAfterCreateAlert(false)}
                        dismissible
                      >
                        Chargepoint <b>{createdChargerId}</b> was created with
                        password <b>{createdChargerPassword}</b>
                      </Alert>

                      <Link to={`/dashboard/chargers/${createdChargerId}`}>
                        <Button variant="link" style={{ padding: '0px' }}>
                          <ArrowRightIcon
                            style={{
                              width: '16px',
                              marginRight: '5px',
                            }}
                          />
                          View Chargepoint
                        </Button>
                      </Link>
                    </div>
                  ) : null} */}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
}
